import style from "./CSS/RoundVideoResult.module.css";
import Round from "../RoundVideoResultOne/Component/Round";
import Title from "../RoundVideoResultOne/Component/Title";
import SubTitle from "../RoundVideoResultOne/Component/SubTitle";
import Banner from "../RoundVideoResultOne/Component/Banner";
import coverPhoto from "../RoundVideoResultOne/img/banner.png";
import Card from "./Component/Card";
import Comment from "./Component/Comment";
import ResultDetails from "./Component/ResultDetails";
import videoImage from "../RoundVideoResultOne/img/video.png";
import MargeCard from "./Component/MargeCard";
import MargeCardTwo from "./Component/MargeCardTwo";
import Slider from "./Component/Slider";

import sliderOne from "../RoundVideoResultTwo/img/sliderOne.png";
import sliderTwo from "../RoundVideoResultTwo/img/sliderThree.png";
import sliderThree from "../RoundVideoResultTwo/img/sliderTwo.png";
import sliderFour from "../RoundVideoResultTwo/img/sliderOne.png";
import sliderFive from "../RoundVideoResultTwo/img/sliderTwo.png";
import sliderSix from "../RoundVideoResultTwo/img/sliderThree.png";
import VideoSlider from "../../../Audition_static/Audition_admin/VideoSlider";
import AuditionNextIncDec from "../../../Audition_static/Audition_admin/AuditionNextIncDec";

const data = [
  { video: videoImage, mark: 54 },
  { video: videoImage, mark: 34 },
  { video: videoImage, mark: 35 },
  { video: videoImage, mark: 78 },
  { video: videoImage, mark: 75 },
  { video: videoImage, mark: 25 },
];

const sliders = [
  { slider: sliderOne },
  { slider: sliderTwo },
  { slider: sliderThree },
  { slider: sliderFour },
  { slider: sliderFive },
  { slider: sliderSix },
];

const RoundVideoResultTwo = () => {
  return (
    <>
      <div className={style.section}>
        <Round round={"01"} status={"running"} />
        <Round round={"02"} status={"pending"} />
        <Round round={"03"} status={"pending"} />
        <Round round={"04"} status={"pending"} />
        <Round round={"05"} status={"pending"} />
        <Round round={"06"} status={"pending"} />
      </div>

      <div>
        <Title title={"round status"} />
      </div>

      <div>
        <SubTitle subTitle={"submitted content"} />
      </div>

      <div>
        <Banner
          title={"1st round time duration june 25 - july 30"}
          coverPhoto={coverPhoto}
        />
      </div>

      <div>
        <Title title={"audition round-1"} />
      </div>

      <div>
        <SubTitle subTitle={"total video - 75"} />
      </div>

      <div>
        {/* <Slider sliders={sliders}/> */}
        <VideoSlider />
      </div>

      <div>
        <Title title={"round1 - final result"} />
      </div>

      <div className="row my-4">
        <div className="col-md-4 d-flex justify-content-center">
          <Card number={"300"} title={"selected user from jury result"} />
        </div>
        <div className="col-md-4 d-flex justify-content-center">
          <Card number={"50"} title={"quality next round user result"} />
        </div>
        <div className="col-md-4 d-flex justify-content-center">
          <Card number={"250"} title={"rejected video result"} />
        </div>
      </div>

      <div className={style.comment__section}>
        <Comment title={"congratulation your are selected for the 3rd round"} />
        <Comment title={"your are rejected for the audition"} />
      </div>

      <div>
        <ResultDetails data={data} />
      </div>

      <div>
        <Title title={"round1 - merge result for next round"} />
      </div>

      <div>
        {/* <MargeCard/> */}
        <AuditionNextIncDec />
      </div>

      <div>
        <Title title={"round1 - merge result for next round"} />
      </div>

      <div>
        {/* <MargeCardTwo/> */}
        <AuditionNextIncDec />
      </div>
    </>
  );
};

export default RoundVideoResultTwo;
